import Analytics from "analytics-node";

const analytics = new Analytics(process.env.SEGMENT_WRITE_KEY as string);

export default analytics;
